/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VIEW = "FORGOT_PASSWORD" | "SIGN_IN" | "SIGN_UP" | "%future added value";
declare const _UserBoxContainerLocal$ref: unique symbol;
export type UserBoxContainerLocal$ref = typeof _UserBoxContainerLocal$ref;
export type UserBoxContainerLocal = {
    readonly authPopup: {
        readonly open: boolean;
        readonly focus: boolean;
        readonly view: VIEW | null;
    };
    readonly accessToken: string | null;
    readonly accessTokenJTI: string | null;
    readonly accessTokenExp: number | null;
    readonly " $refType": UserBoxContainerLocal$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "UserBoxContainerLocal",
    "type": "Local",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authPopup",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AuthPopup",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "open",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "focus",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "view",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "accessToken",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "accessTokenJTI",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "accessTokenExp",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '96fa11fdab9ecd63b47e8ad12af854d7';
export default node;
